import React, { Component } from 'react';
import {
  Label,
  Input,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu
} from 'reactstrap';
import ReactSelect from 'react-select';
import { components } from 'react-select';
import { connect } from 'react-redux';
import * as sideBarActions from '../../redux/sideBarActions';
import { bindActionCreators } from 'redux';
import './ColorSelector.scss';

class ColorSelector extends Component {
  render() {
    const {
      label,
      colors,
      placeholder,
      pickerEnable,
      onClearColor,
      onSelectColor,
      style,
      dispatchers
    } = this.props;

    const Option = props => {
      const { innerProps, innerRef } = props;
      return (
        <div ref={innerRef} {...innerProps} style={{ padding: '2px 5px' }}>
          <img alt={props.data.name} src={props.data.thumbnail_path} />
        </div>
      );
    };

    const SingleValue = ({ children, ...props }) => (
      <components.SingleValue {...props}>
        <span className='selected-font'>{props.data.name}</span>
      </components.SingleValue>
    );

    const IndicatorSeparator = ({ innerProps }) => (
      <span className='indicator-separator' {...innerProps} />
    );

    return (
      <div id='colorSelect' className='d-flex flex-column h-100 '>
        <div className='flex-grow-1 color-content-box color-theme-wrapper'>
          <div id='text-p' className='text-left '>
            <UncontrolledDropdown>
              <DropdownToggle tag='div'>
                <ReactSelect
                  id='react-select-shadow-dropdown'
                  components={{ Option, SingleValue, IndicatorSeparator }}
                  placeholder={placeholder}
                  isSearchable={false}
                  isDisabled
                  styles={style}
                />
              </DropdownToggle>
              <DropdownMenu className='dropdown-color-select'>
                <div
                  role='button'
                  style={{ outline: 'none' }}
                  tabIndex='0'
                  onKeyPress={() => {}}
                  className='defaultLabel'
                  onClick={onClearColor}
                >
                  {label}
                </div>
                <div className='colors'>
                  {colors.map(color => (
                    <Label check key={color}>
                      <Input
                        type='radio'
                        name='shadowColor'
                        value={color}
                        onClick={e => {
                          e.stopPropagation();
                          onSelectColor(e);
                        }}
                      />

                      <div className='colorBox' style={{ background: color }} />
                    </Label>
                  ))}
                  {pickerEnable === true ? (
                    <Label check>
                      <Input
                        type='radio'
                        onChange={e => {
                          e.stopPropagation();
                          dispatchers.patternColorPickerHandler();
                        }}
                      />
                      <div className='colorBox plus-image' />
                    </Label>
                  ) : null}
                </div>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    searchTags: state.sideBar.searchTags,
    colorToSearch: state.sideBar.colorToSearch,
    showPicker: state.sideBar.showColorPicker
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: bindActionCreators(sideBarActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ColorSelector);
